// extracted by mini-css-extract-plugin
export default {"alertContainer":"styles_alertContainer__Perqb","homeDeliveryContainer":"styles_homeDeliveryContainer__EvusJ","offboardingPharmacyName":"styles_offboardingPharmacyName__zS5vU"};